import styleInject from '../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".progressBarContainer-library--Afp2Z {\n  width: 100%;\n  min-height: 4px;\n  background-color: #dfdfdf;\n}\n.progressBarContainer-library--Afp2Z .progressBar-library--gAVew {\n  height: 100%;\n  background-color: #ed002f;\n}";
var styles = {"progressBarContainer":"progressBarContainer-library--Afp2Z","progressBar":"progressBar-library--gAVew"};
styleInject(css_248z);

export { styles as default };
